// extracted by mini-css-extract-plugin
module.exports = {"card":"monster-card_card__7Dntj","name":"monster-card_name__1fx8u","email":"monster-card_email__2qtAT"};